import React, { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';

import useResize from 'src/shared/hooks/useResize';
import ListItem from 'src/pages/NewsList/components/ListItem';

import styles from './styles.module.scss';
import FeaturedFromOthersCards from '../../../FeaturedFromOtherCards';
import BREAKPOINT from 'src/shared/config/Breakpoint';
import ArticlePostModel from 'src/types/article/ArticlePostModel';

interface Props {
    isSideColumnShown: boolean;
    isFetchingAdditional: boolean;
    basicEvents: ArticlePostModel[];
    additionalEvents: ArticlePostModel[];
    featuredFromOthers: ArticlePostModel[];
}

const EventList = ({ isFetchingAdditional, isSideColumnShown, basicEvents, additionalEvents, featuredFromOthers }: Props) => {
    const { t } = useTranslation();
    const { screenSize } = useResize();
    const [pinnedEvent, setPinnedEvent] = useState(null);
    const [comingEvents, setComingEvents] = useState([]);
    const [pastEvents, setPastEvents] = useState([]);

    const sortAsc = (a, b) => (a.startDate > b.startDate ? 1 : -1);
    const sortDesc = (a, b) => (a.startDate <= b.startDate ? 1 : -1);

    // TODO improve efficiency
    useEffect(() => {
        const currentTime = new Date().getTime();
        const coming = [];
        const past = [];

        basicEvents.concat(additionalEvents).forEach((item) => {
            if (item.startDate > currentTime) {
                coming.push(item);
            } else {
                past.push(item);
            }
        });

        // Sort coming and past events from cloest to farthest
        coming.sort(sortAsc);
        past.sort(sortDesc);

        // Set featured event
        if (!coming.length && !past.length) {
            setPinnedEvent(null);
        } else {
            setPinnedEvent(coming.length ? coming.shift() : past.shift());
        }

        setComingEvents(coming);
        setPastEvents(past);
    }, [basicEvents, additionalEvents]);

    return (
        <div className={styles.eventListContainer}>
            {!!pinnedEvent && <ListItem type="pinned" item={pinnedEvent} screenWidth={screenSize.width} />}
            {!!comingEvents.length && (
                <div className={styles.comingEvents}>
                    <div className={styles.title}>{t('coming_events_title')}</div>
                    {comingEvents.map((item, idx) => (
                        <ListItem key={`coming-event-${idx}`} className={styles.comingEvent} item={item} screenWidth={screenSize.width} />
                    ))}
                </div>
            )}
            {!isSideColumnShown && !!featuredFromOthers.length && (
                <div className={styles.featuredFromOthersContainer}>
                    <FeaturedFromOthersCards items={featuredFromOthers} isColumn={screenSize.width < BREAKPOINT.PHONE} />
                </div>
            )}
            {!!pastEvents.length && (
                <div>
                    <div className={styles.title}>{t('past_events_title')}</div>
                    {pastEvents.map((item, idx) => (
                        <ListItem key={`past-event-${idx}`} item={item} screenWidth={screenSize.width} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default EventList;
